import { render } from "./DocumentsList.vue?vue&type=template&id=710ee0ae&scoped=true"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"

import "../../assets/scss/documents_list.scss?vue&type=style&index=0&id=710ee0ae&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710ee0ae"]])

export default __exports__